//Devices constants

export const GET_RULES_ATTEMPT = "GET_RULES_ATTEMPT";
export const GET_RULES_SUCCESS = "GET_RULES_SUCCESS";
export const GET_RULES_FAILURE = "GET_RULES_FAILURE";
export const CLEAR_RULES_STATE = "CLEAR_RULES_STATE";

export const CLEAR_STATE = "CLEAR_STATE";
